import {
  ChangeDetectionStrategy, ChangeDetectorRef,
  Component,
  EventEmitter,
  forwardRef, HostBinding, Inject, InjectFlags, Injector, INJECTOR,
  Input,
  OnInit, Optional,
  Output,
  Renderer2,
  ViewContainerRef
} from '@angular/core';
import {ControlValueAccessor, NG_VALUE_ACCESSOR, NgControl} from "@angular/forms";
import {INT_TESTING_DATA_MARKERS_TOKEN} from "../../tokens";
import {IntTestingDataMarkers} from "../../types";

@Component({
  selector: 'int-switch',
  templateUrl: './int-switch.component.html',
  styleUrls: ['./int-switch.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => IntSwitchComponent),
      multi: true
    }
  ],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class IntSwitchComponent implements OnInit, ControlValueAccessor {
  @Input() size = "md";
  @Input() disabled: boolean | undefined = false;
  @Input() checked = false;
  @Input() readonly = false;
  @Input() valueAsBoolean = true;
  @Input() fieldTestMark: string | null = null;
  @Input() fieldAddedTestMark: string | null = null;

  @Output() handleChangeEvent = new EventEmitter();

  value: unknown | null = null;

  constructor(
    protected host: ViewContainerRef,
    protected renderer: Renderer2,
    private readonly cdr: ChangeDetectorRef,
    @Optional()
    @Inject(INJECTOR) private injector: Injector,
    @Optional()
    @Inject(INT_TESTING_DATA_MARKERS_TOKEN) readonly testingMarkers: IntTestingDataMarkers
  ) { }

  get controlRef() {
    return this.injector?.get(NgControl, null, InjectFlags.Optional)
  }

  @HostBinding('class._is-disabled')
  get isDisabled() {
    return this.disabled || this.controlRef?.disabled
  }

  @HostBinding('attr.data-state')
  get checkedStatus() {
    return this.checked ? 'checked' : 'unchecked';
  }

  onChange(status: boolean ) {}

  handleChange(value: Event): any {
    const _value = (value.target as any).checked;
    this.checked = !!_value;
    this.onChange(_value);
    this.handleChangeEvent.emit(this.value);
  }

  onTouched() {}

  writeValue(value: any): void {
    this.value = this.valueAsBoolean ? !!value : value;
    this.checked = !!value;
    this.onChange(value);
  }

  registerOnChange(fn: any): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }

  setDisabledState?(isDisabled: boolean | undefined): void {
    this.disabled = isDisabled;
    this.cdr.markForCheck();
  }

  ngOnInit(): void {
    const element = this.host.element.nativeElement;
    const read = this.readonly ? 'readonly' : null;
    const propsList = [
      this.size
    ];
    if(read) {propsList.push(read)}
    propsList.forEach((prop: string) => {
      this.renderer.addClass(element, prop);
    });
  }
}
